module.exports = function() {
  return new Worker(__webpack_public_path__ + "9ce2b5b50b4f4ebbead9.worker.js");
};